import React, { useState, useEffect, useCallback } from 'react';
import AddAgent from '../../AddsEdits/Adult/AddAgent.js';
import EditAgent from '../../AddsEdits/Adult/EditAgent.js';
import { SERVER_URL } from '../../../constants.js'

function Agent(props) {
  const { selectedPerson } = props;
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [adult, setAdult] = useState(null);
  const [agent, setAgent] = useState(null);
  
  const fetchAdult = useCallback(() => {
    const token = sessionStorage.getItem('bearer');
    fetch(`${SERVER_URL}api/adult/${selectedPerson.id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.status === 204) {
          return null;
        } else if (response.ok) {
          return response.json();
        } else {
          throw new Error('Failed to fetch adult');
        }
      })
      .then((data) => {
        setAdult(data);
      })
      .catch((err) => console.error(err));
  }, [selectedPerson.id]);

  const fetchAgent = useCallback(() => {
    const token = sessionStorage.getItem('bearer');
    fetch(`${SERVER_URL}api/agent/${selectedPerson.id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.status === 204) {
          return null;
        } else if (response.ok) {
          return response.json();
        } else {
          throw new Error('Failed to fetch agent');
        }
      })
      .then((data) => {
        if (data && data.length > 0) {
          setAgent(data[0]);
          setShowEditDialog(true);
          setShowAddDialog(false);
        } else {
          setAgent(null);
          setShowAddDialog(true);
          setShowEditDialog(false);
        }
      })
      .catch((err) => console.error(err));
  }, [selectedPerson.id]);

  useEffect(() => {
    fetchAdult();
    fetchAgent();
  }, [fetchAdult, fetchAgent]);

  let imgPath= process.env.PUBLIC_URL || '/assets/img/agent.png';
  console.log(imgPath);

  const {
    id: AdultId, 
    dateAdded, 
    adultName, 
    adultSurname, 
    adultEmail, 
    adultPhone, 
    adultNationality, 
    allergies, 
    notes
  } = adult || {};

  const {
    id: AgentId, 
    englishSpeaking, 
    commission, 
    commissionRate,
    notes: agentNotes
  } = agent || {};

  const editAgent = (agent, id) => {
    const token = sessionStorage.getItem("bearer"); 
    fetch(`${SERVER_URL}api/agent/${id}`, {
      method: 'PUT', 
      headers: {
        'Content-Type':'application/json',
        'Authorization' : `Bearer ${token}`
      },
      body: JSON.stringify(agent)
    })
    .then(response => {
      if (response.ok) {
        fetchAgent();
      }
      else {
        alert('Something went wrong!');
      }
    })
    .catch(err => console.error(err))
  }

  const addAgent = (agent) => {
    const token = sessionStorage.getItem("bearer"); 
    fetch(`${SERVER_URL}api/agent/${AdultId}`, {
      method: 'POST', 
      headers: {
        'Content-Type':'application/json',
        'Authorization' : `Bearer ${token}`
      },
      body: JSON.stringify(agent)
    })
    .then(response => {
      if (response.ok) {
        fetchAgent();
      }
      else {
        alert('Something went wrong!');
      }
    })
    .catch(err => console.error(err))
  }

  return (
    <React.Fragment>
      <div className="detail-card" style={{ padding: '20px 0' }}>
        <table style={{ width: '80%', textAlign: 'left', margin: 'auto', borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td rowSpan="2" style={{ textAlign: 'center' }}><img className="br-0 h3 w3 dib" alt={selectedPerson.id} src={imgPath} /></td>
              <td>DB ref: {AdultId}</td>
              <td>Added: {dateAdded}</td>
            </tr>
            <tr>
            <td style={{ textAlign: 'left' }}>{adultName} {adultSurname}</td>
            <td>Nationality: {adultNationality}</td>
            </tr>
            <tr>
            
              
              <td colSpan="1"></td>
              <td>Email: {adultEmail}</td>
            <td>Phone: {adultPhone}</td>
            </tr>
            <tr style={{ height: '50px' }}><td colSpan="4" > </td></tr>
            <tr><td>Agent Id: </td><td colSpan="3">{AgentId}</td></tr>
            <tr><td>English Speaking?:</td>  <td colSpan="3">
              {agent 
                ? (englishSpeaking ? 'Yes' : 'No') 
                : ''}
            </td></tr>
            <tr><td>Commission type:</td><td colSpan="3">{commission}</td></tr>
            <tr><td>Commission rate (%):</td><td colSpan="3">{commissionRate}</td></tr>
            <tr><td>notes:</td><td colSpan="3">{agentNotes}</td></tr>
          </tbody>
        </table>
      </div>
      <div>
        <div style={{ color: '#999999', fontSize: '10px' }}>Adult: {selectedPerson.id}
          {agent ? (
            <EditAgent passedAgent={agent} editAgent={editAgent} />
          ) : (
            <AddAgent addAgent={addAgent}/>
          )}
        </div>
        <div style={{ color: '#999999', fontSize: '10px' }}>Is authenticated: {sessionStorage.getItem('isAuthenticated') ? 'Yes' : 'No'}</div>
      </div>
    </React.Fragment>
  );
}

export default Agent;
